// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"styles-module--fadeIn--2XGxB","second":"styles-module--second--2wyqw","third":"styles-module--third--Dprlg","basicButton":"styles-module--basic-button--ddCTd"};